import React from 'react';
import classNames from 'classnames';
import styles from './Button.module.scss';
import { IButton, ButtonVariant, ButtonStyle, ButtonSize } from './Button.types';

const ButtonVariantClassName = {
  [ButtonVariant.text]: 'btn-text',
  [ButtonVariant.contained]: 'btn-contained',
  [ButtonVariant.outlined]: 'btn-outlined',
};

const ButtonStyleClassName = {
  [ButtonStyle.primary]: 'btn-primary',
  [ButtonStyle.secondary]: 'btn-secondary',
  [ButtonStyle.danger]: 'btn-danger',
  [ButtonStyle.success]: 'btn-success',
};

const ButtonSizeClassName = {
  [ButtonSize.small]: 'btn-small',
  [ButtonSize.medium]: 'btn-medium',
  [ButtonSize.large]: 'btn-large',
  [ButtonSize.xlarge]: 'btn-xlarge',
};

export const Button: React.FC<IButton> = ({
  children,
  type = 'button',
  className = '',
  variant = ButtonVariant.contained,
  styleType = ButtonStyle.primary,
  size = ButtonSize.medium,
  ...restProps
}) => {
  const classes = classNames(
    className,
    styles['ds-btn-element'],
    styles[ButtonVariantClassName[variant]],
    styles[ButtonStyleClassName[styleType]],
    styles[ButtonSizeClassName[size]]
  );

  return (
    <button {...restProps} className={classes} type={type}>
      {children}
    </button>
  );
};
